import React from 'react';
import './Loader.scss';
import logo from '../../../assets/brandLogo.png';

const Loader = () => (
  <div className="Loader__container">
    <div className="Loader">
      <img src={logo} alt="Loading" className="Loader__image" />
      <div className="Loader__spinner">
        <div className="Loader__dot" />
        <div className="Loader__dot" />
        <div className="Loader__dot" />
      </div>
    </div>
  </div>
);

export default Loader;
